var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgPnpSendamount = function SvgImgPnpSendamount(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M17.828 4.956c.113.25.172.52.172.794v8.437a1.92 1.92 0 0 1-2.715 1.748L9.2 13.169l-.857-.001.456 1.775c.023.089.038.18.046.272l.006.138c0 .912-.74 1.65-1.651 1.65h-.455a1.68 1.68 0 0 1-1.628-1.261l-.614-2.394a.695.695 0 0 1-.023-.18h-.56A1.92 1.92 0 0 1 2 11.248v-2.56c0-1.06.86-1.92 1.92-1.92H9.2l6.085-2.765a1.92 1.92 0 0 1 2.543.953zM6.88 13.168h-.937l.57 2.216a.238.238 0 0 0 .168.171l.064.009H7.2a.21.21 0 0 0 .204-.263l-.501-1.953a.695.695 0 0 1-.023-.18zm9.001-7.855L9.796 8.08a1.44 1.44 0 0 1-.596.129l-2.56-.001v3.52H9.2c.206 0 .409.045.596.13l6.085 2.766a.48.48 0 0 0 .679-.437V5.75a.481.481 0 0 0-.679-.437zM5.2 11.728v-3.52H3.92a.48.48 0 0 0-.48.48v2.56c0 .266.215.48.48.48H5.2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#21B5CD",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2A394D",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgPnpSendamount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-pnp-sendamount.c79b4d6062c6c2da9a42a3aa5200daca.svg";